"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./AlbertaOtherFeatures.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-430":{"id":"e-430","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-431"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"395cd987-846e-63b2-9777-2fb893e0c302","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"395cd987-846e-63b2-9777-2fb893e0c302","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1716319753300},"e-432":{"id":"e-432","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-433"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"395cd987-846e-63b2-9777-2fb893e0c304","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"395cd987-846e-63b2-9777-2fb893e0c304","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"LEFT","effectIn":true},"createdOn":1716319766738},"e-434":{"id":"e-434","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-435"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"395cd987-846e-63b2-9777-2fb893e0c307","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"395cd987-846e-63b2-9777-2fb893e0c307","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"LEFT","effectIn":true},"createdOn":1716319778441},"e-436":{"id":"e-436","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-437"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"395cd987-846e-63b2-9777-2fb893e0c310","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"395cd987-846e-63b2-9777-2fb893e0c310","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"LEFT","effectIn":true},"createdOn":1716319794492},"e-438":{"id":"e-438","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-439"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"395cd987-846e-63b2-9777-2fb893e0c319","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"395cd987-846e-63b2-9777-2fb893e0c319","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":"LEFT","effectIn":true},"createdOn":1716319806465}},"actionLists":{"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]},"slideInLeft":{"id":"slideInLeft","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":-100,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}},{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function AlbertaOtherFeatures({ as: _Component = _Builtin.Section }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "alberta_section-other-features")}
      grid={{
        type: "section",
      }}
      tag="section"
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "container-large")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "padding-section-medium")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "padding-global")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "alberta_container-other-features",
                "max-width-xxlarge",
                "align-center"
              )}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "alberta_other-features-heading",
                  "text-align-center"
                )}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "alberta_other-features-copy-wrap"
                  )}
                  tag="div"
                >
                  <_Builtin.Heading
                    className={_utils.cx(
                      _styles,
                      "alberta_other-features-heading"
                    )}
                    data-w-id="395cd987-846e-63b2-9777-2fb893e0c302"
                    tag="h3"
                  >
                    {"Take the stress out of renting"}
                  </_Builtin.Heading>
                  <_Builtin.Paragraph
                    className={_utils.cx(_styles, "text-color-secondary")}
                    data-w-id="395cd987-846e-63b2-9777-2fb893e0c304"
                  >
                    {
                      "Streamline your rental management from start to finish with liv.rent's all-in-one features."
                    }
                  </_Builtin.Paragraph>
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "alberta_other-features-grid")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "alberta_other-features-card")}
                  data-w-id="395cd987-846e-63b2-9777-2fb893e0c307"
                  tag="div"
                >
                  <_Builtin.Image
                    className={_utils.cx(_styles, "icon-height-medium")}
                    loading="lazy"
                    width="auto"
                    height="auto"
                    alt=""
                    src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/66479bf1da7bdb9d1e365ea3_icon-sponsored.svg"
                  />
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "alberta_other-features-copy"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "alberta_other-features-card-heading",
                        "text-weight-bold"
                      )}
                      tag="div"
                    >
                      <_Builtin.Paragraph>
                        {"Sponsored Listings"}
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "alberta_other-features-card-description",
                        "text-size-small"
                      )}
                      tag="div"
                    >
                      <_Builtin.Paragraph
                        className={_utils.cx(
                          _styles,
                          "alberta_other-features-card-description"
                        )}
                      >
                        {
                          "Get up to 300% more views by boosting your listing to the top of relevant search results."
                        }
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "alberta_other-features-card")}
                  data-w-id="395cd987-846e-63b2-9777-2fb893e0c310"
                  tag="div"
                >
                  <_Builtin.Image
                    className={_utils.cx(_styles, "icon-height-medium")}
                    loading="lazy"
                    width="auto"
                    height="auto"
                    alt=""
                    src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6643f1e74274d725bde6bf5a_icon-syndication.svg"
                  />
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "alberta_other-features-copy"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "alberta_other-features-card-heading",
                        "text-weight-bold"
                      )}
                      tag="div"
                    >
                      <_Builtin.Paragraph>
                        {"Create Contracts"}
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "alberta_other-features-card-description",
                        "text-size-small"
                      )}
                      tag="div"
                    >
                      <_Builtin.Paragraph
                        className={_utils.cx(
                          _styles,
                          "alberta_other-features-card-description"
                        )}
                      >
                        {
                          "Quickly create legally-vetted contracts with pre-loaded Alberta lease agreement templates."
                        }
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "alberta_other-features-card")}
                  data-w-id="395cd987-846e-63b2-9777-2fb893e0c319"
                  tag="div"
                >
                  <_Builtin.Image
                    className={_utils.cx(_styles, "icon-height-medium")}
                    loading="lazy"
                    width="auto"
                    height="auto"
                    alt=""
                    src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6643f1e7fa63a0ba2428b16f_icon-contracts.svg"
                  />
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "alberta_other-features-copy"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "alberta_other-features-card-heading",
                        "text-weight-bold"
                      )}
                      tag="div"
                    >
                      <_Builtin.Paragraph>
                        {"Automated Rental Payments"}
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "alberta_other-features-card-description",
                        "text-size-small"
                      )}
                      tag="div"
                    >
                      <_Builtin.Paragraph
                        className={_utils.cx(
                          _styles,
                          "alberta_other-features-card-description"
                        )}
                      >
                        {
                          "Set payment reminders and get paid on time, every time directly through liv.rent."
                        }
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
